<template>
  <ExternalQueryList
      headline="Primary Menu Links"
      endpoint="/api/v2/primary-menu-links"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/primary-menu-links/priorities"
      :get-reorder-payload="data => ({primary_menu_links: data})"
      @show="primaryMenuLink => $router.push(getUrl(primaryMenuLink))"
  >
    <template v-slot:default="{ row: primaryMenuLink }">
      <td>
        <router-link :to="getUrl(primaryMenuLink)">
          {{ primaryMenuLink.attributes.text }}
        </router-link>
      </td>

      <td>
        {{ primaryMenuLink.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/primary-menu-links/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Text'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(primaryMenuLink) {
      return '/portals/' + this.portal.id + '/content/primary-menu-links/' + primaryMenuLink.id + '/edit'
    }
  }
}
</script>
